<template>
    <div>
        <page-header :title="isInEditMode ? $t('pages.admin.series.title_update') + ': ' + title[$i18n.locale] : $t('pages.admin.series.title_create')" icon-class="mdi mdi-television"/>

        <img :src="current_thumbnail_url" class="img-fluid mb-4 rounded" v-if="current_thumbnail_url !== null">

        <div class="card shadow-sm">
            <div class="card-body">
                <div class="form-group">
                    <strong>
                        <label for="slug">{{ $t('pages.admin.series.model.slug') }}</label>
                    </strong>
                    <input id="slug" type="text" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('slug'), 'disabled': isInEditMode}" :placeholder="$t('pages.admin.series.model.slug')" v-model="slug"
                    :disabled="isInEditMode">
                    <error input="slug"></error>
                    <small class="form-text text-muted">{{ $t('pages.admin.series.slug_explanation') }}</small>
                </div>

                <div class="form-group" >
                    <label>
                        <strong>
                            {{ $t('pages.admin.series.management.select_thumbnail') }}
                        </strong>
                    </label>
                    <input type="file" class="file-upload-default" id="file" :class="{'is-invalid': $errors.has('file')}" @change="fileSelected">
                    <div class="input-group cursor-pointer col-xs-12" @click="showSelectFileDialog">
                        <input type="text" class="form-control file-upload-info" disabled="" :placeholder="$t('pages.admin.series.management.select_thumbnail')">
                        <span class="input-group-append">
                            <button class="file-upload-browse btn btn-gradient-primary" type="button">{{ $t('actions.select') }}</button>
                        </span>
                        <error input="file"/>
                    </div>
                    <small class="form-text text-muted">{{ $t('pages.admin.series.file_explanation') }}</small>

                </div>


                <language-switcher-nav :language.sync="selectedLanguage">
                    <div class="form-group">
                        <label :for="'title_' + selectedLanguage">{{ $t('pages.admin.faq.global.title') }}</label>
                        <input :id="'title_' + selectedLanguage" type="text" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('title.' + selectedLanguage)}" :placeholder="$t('pages.admin.faq.global.title')" v-model="title[selectedLanguage]">
                        <error-no-form-field :input="'title.' + selectedLanguage"/>
                    </div>
                    <div class="form-group">
                        <label :for="'desc_' + selectedLanguage">{{ $t('pages.admin.faq.global.desc') }}</label>
                        <input :id="'desc_' + selectedLanguage" type="text" class="form-control form-control-lg" :class="{'is-invalid': $errors.has('description.' + selectedLanguage)}" :placeholder="$t('pages.admin.faq.global.desc')" v-model="description[selectedLanguage]">
                        <error-no-form-field :input="'description.' + selectedLanguage"/>
                    </div>
                </language-switcher-nav>

                <div class="form-group">
                    <div class="form-check form-check-primary mt-4">
                        <label class="form-check-label">
                            <input type="checkbox" class="form-check-input" v-model="show_in_sidebar">
                            {{ $t('pages.admin.series.model.show_in_sidebar') }}
                            <i class="input-helper"></i>
                        </label>
                        <error-no-form-field input="show_in_sidebar"/>
                    </div>
                </div>
                <div class="form-group">
                    <div class="form-check form-check-primary mt-4">
                        <label class="form-check-label">
                            <input type="checkbox" class="form-check-input" v-model="show_in_coach">
                            {{ $t('pages.admin.series.model.show_in_coach') }}
                            <i class="input-helper"></i>
                        </label>
                        <error-no-form-field input="show_in_coach"/>
                    </div>
                </div>

                <button class="btn btn-primary" @click="saveSeries">
                    {{ isInEditMode ? $t('actions.update') : $t('actions.create') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import AdminSeriesRepository from "../../../repositories/Admin/AdminSeriesRepository";
import PageHeader from "../../Includes/PageHeader";
import LanguageSwitcherNav from "../../Includes/LanguageSwitcherNav";

export default {
    name: "SeriesAddUpdate",
    components: {LanguageSwitcherNav, PageHeader},
    data: () => ({
        selectedLanguage: 'en',

        file: null,
        slug: '',
        title: {
            en: '',
            de: '',
            lb: '',
        },
        description: {
            en: '',
            de: '',
            lb: '',
        },
        show_in_sidebar: false,
        show_in_coach: false,

        current_thumbnail_url: null,
    }),
    mounted() {
        if(this.isInEditMode) {
            AdminSeriesRepository
                .getSeries(this.seriesSlug)
                .then((res) => {
                    this.title = res.data.title;
                    this.description = res.data.description;

                    if(res.data.description === null) {
                        this.description = {
                            en: '',
                            de: '',
                            lb: '',
                        }
                    }

                    this.show_in_sidebar = res.data.show_in_sidebar;
                    this.show_in_coach = res.data.show_in_coach;
                    this.current_thumbnail_url = res.data.thumbnail_url;
                });
        }
    },
    methods: {
        /* File Upload */
        fileSelected(e) {
            this.file = e.target.files[0];
            let fileUploadInfoInput = document.getElementsByClassName('file-upload-info')[0];
            fileUploadInfoInput.value = this.file.name;
            fileUploadInfoInput.value = fileUploadInfoInput.value.replace(/C:\\fakepath\\/i, '');
        },
        showSelectFileDialog() {
            let file = document.getElementsByClassName('file-upload-default')[0];
            file.click();
        },

        /* Series */
        updateSeries() {
            AdminSeriesRepository
                .updateSeries(this.seriesSlug, this.getFormData()).then((res) => {
                    this.$snotify.success(this.$t('actions.updated'));
                    this.$router.push({name: 'admin.series.index'});
                });
        },
        getFormData() {
            let formData = new FormData();
            if(this.file !== null)
                formData.append('file', this.file);
            if(!this.isInEditMode)
                formData.append('slug', this.slug);

            formData.append('title[en]', this.title.en);
            formData.append('title[de]', this.title.de);
            formData.append('title[lb]', this.title.lb);
            formData.append('description[en]', this.description.en);
            formData.append('description[de]', this.description.de);
            formData.append('description[lb]', this.description.lb);
            formData.append('show_in_sidebar', this.show_in_sidebar);
            formData.append('show_in_coach', this.show_in_coach);

            return formData;
        },
        addSeries() {
            AdminSeriesRepository
                .createSeries(this.getFormData()).then((res) => {
                this.$snotify.success(this.$t('actions.updated'));
                this.$router.push({name: 'admin.series.index'});
            });
        },
        saveSeries() {
            if(this.isInEditMode)
                this.updateSeries();
            else
                this.addSeries();
        },
    },
    computed: {
        seriesSlug() {
            return this.$route.params.slug;
        },
        isInEditMode() {
            return this.seriesSlug !== undefined;
        }
    }
}
</script>

<style scoped>

</style>
